import "./login.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import React from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import createApiClient from "../../utils/axiosConfig";
import { FaReact } from "react-icons/fa";

function Login() {
  const api = createApiClient(process.env.REACT_APP_BASE_URL);
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await api.post(`signin`, values);
      if (response.status === 200) {
        if (response?.data.data?.role === 1) {
          localStorage.setItem("adminToken", response.data.token);
          localStorage.setItem("adminLogin", 1);
          localStorage.setItem(
            "adminData",
            JSON.stringify(response?.data.data)
          );
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userdata", JSON.stringify(response?.data.data));
          navigate("/admin");
        } else {
          toast.error("Only Admin have access not users");
        }
        resetForm();
      } else {
        navigate("/admin-login");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="d-flex row justify-content-center login align-items-center vh-100 roboto_fonts">
      <div className="h-100 d-flex flex-column">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className=" m-auto p-5 h-full bg-white col-lg-5 mx-auto">
              <div className="d-flex justify-content-center">
                <FaReact size={30} className=" mb-2" />
              </div>
              <h3 className="font-weight-bold text-center">Admin Sign In</h3>
              <div className="my-4">
                <Field
                  type="email"
                  name="email"
                  className="form-control form-control-lg"
                  placeholder="Enter email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="mb-4">
                <Field
                  type="password"
                  name="password"
                  className="form-control form-control-lg"
                  placeholder="Enter password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />
              </div>
              <div className="mb-4 d-flex justify-content-between">
                <div className="custom-control custom-checkbox d-flex gap-2">
                  <Field
                    type="checkbox"
                    name="rememberMe"
                    id="customCheck1"
                    className="custom-control-input mr-2"
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="customCheck1"
                  >
                    Remember me
                  </label>
                </div>               
              </div>
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn login_btn btn-primary border-0 p-3 rounded-pill p"
                  disabled={isSubmitting}
                >
                  Sign in
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <div className="footer">
          <p className="text-center text-muted  pt-2">
            Copyright © <span> ReactJS</span> 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
